const Footer = () => {
  return (
    <footer>
      <p>Crafted by <span>Corey</span>, <span>Michael</span>, <span>Tiff</span>, and <span>Taz</span></p>
    </footer>
  )
}

export default Footer;